/**
 * UnarchiveIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const UnarchiveIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m11.28 5.285-3 3a.948.948 0 0 0 .67 1.62c.24 0 .49-.09.67-.28L11 8.245v4.38c0 .52.43.95.95.95s.95-.43.95-.95v-4.38l1.38 1.38c.19.19.43.28.67.28s.49-.09.67-.28c.37-.37.37-.97 0-1.34l-3-3a.945.945 0 0 0-1.35 0z" />
    <path d="M20.74 3.16A3.92 3.92 0 0 0 17.95 2h-2c-.52 0-.95.43-.95.95s.43.95.95.95h2c.55 0 1.06.21 1.45.6.38.38.6.91.6 1.45V14h-3.43c-.36 0-.72.1-1.03.29s-.56.46-.72.79l-.49.92-4.81-.03-.45-.9c-.16-.32-.41-.6-.72-.79s-.66-.29-1.03-.29H3.9V5.95c0-.55.21-1.06.6-1.45s.9-.6 1.45-.6h2c.52 0 .95-.43.95-.95S8.47 2 7.95 2h-2c-1.06 0-2.05.41-2.79 1.16C2.41 3.9 2 4.89 2 5.95v12c0 1.06.41 2.05 1.16 2.79a3.92 3.92 0 0 0 2.79 1.16h12c1.05 0 2.05-.41 2.79-1.16S21.9 19 21.9 17.95v-12c0-1.05-.41-2.05-1.16-2.79M19.4 19.4c-.39.39-.9.6-1.45.6h-12c-.54 0-1.07-.22-1.45-.6-.39-.39-.6-.9-.6-1.45v-2.04l3.48.02.45.9c.16.32.41.6.72.79s.66.29 1.03.29h4.76c.36 0 .72-.1 1.03-.29s.56-.46.72-.79l.49-.92h3.43v2.05c0 .55-.21 1.06-.6 1.45z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const UnarchiveIcon = makeIcon('UnarchiveIcon', UnarchiveIconSvg)
